import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/collector-auth/password-reset/request", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="container-gm py-16 max-w-md">
      <SEO title="Forgot password" />
      <div className="kicker kicker-red">Collector Registry</div>
      <h1 className="h-display text-4xl mt-3">Reset your password</h1>

      {sent ? (
        <div className="mt-8 rounded-3xl border-2 border-[var(--ink)] bg-white p-6" data-testid="forgot-success">
          <p className="text-[var(--smoke)]">If an account exists for <span className="text-[var(--ink)] font-bold">{email}</span>, we&apos;ve sent a reset link. Check your inbox.</p>
          <Link to="/login" className="btn-ghost text-sm mt-4 inline-flex">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
          <label className="block">
            <div className="kicker kicker-black text-[11px] mb-1">Email</div>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="gm-field" />
          </label>
          <button type="submit" disabled={busy} data-testid="forgot-submit" className="btn-red text-sm w-full disabled:opacity-60">
            {busy ? "Sending…" : "Send reset link"}
          </button>
          <p className="text-sm text-[var(--smoke)]">Remembered it? <Link to="/login" className="underline font-bold text-[var(--ink)]">Sign in</Link></p>
        </form>
      )}
    </div>
  );
}
